import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", { style: {"padding-left":"10px"} }, "课件库", -1)
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" 清空 ")
const _hoisted_4 = { style: {"float":"right"} }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 重置 ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("查询")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("上架")
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("下架")
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode("预览")
const _hoisted_13 = [
  _hoisted_12
]

import { onBeforeMount, onMounted, ref, toRaw } from 'vue'
import { useStore } from 'vuex'
import { AppstoreFilled, UnorderedListOutlined } from '@ant-design/icons-vue'
import { debounce } from '@/utils/common'
import {
  disableInstitutionTeacherCourseware,
  enableInstitutionTeacherCourseware,
  getInstitutionShareCoursewares,
  getInsSubjectEnum,
  getInsPrevissionEnum,
  addInstitutionViewLog
} from '@/services/courseware-database'
import {
  CoursewareStatusMap,
  CoursewareTypeMap,
  CoursewareType,
  CoursewareTypeOpts,
  CoursewareStatus,
  CoursewareStatusOpts
} from '../config'
import { PermissionMap } from '@/utils/auth'
import PptCoursewareCard from './components/PptCoursewareCard.vue'
import ImageCoursewareCard from './components/ImageCoursewareCard.vue'
import VideoCoursewareCard from './components/VideoCoursewareCard.vue'
import AudioCoursewareCard from './components/AudioCoursewareCard.vue'
import FlashCoursewareCard from './components/FlashCourswareCard.vue'
import SpeakCoursewareCard from './components/SpeakCoursewareCard.vue'
import PlanCoursewareCard from './components/PlanCoursewareCard.vue'
import { useRouter } from 'vue-router'
import { message } from 'ant-design-vue'
import PreviewModal from '../components/PreviewModal.vue'
import SelectBookModal from '@/views/songs/components/SelectBookModal.vue'
import { usePageTableContext } from '@evideo/frontend-utils'
import pageTableContextMap from '@/utils/pageTableContextMap'


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()

const router = useRouter()

// 列表的内容
const tableData = ref<any[]>([])

// 搜索表单数据
const formData = ref<any>({
  name: undefined,
  author_school_name: undefined,
  type: undefined,
  subject_cat_id: undefined,
  press_version_id: undefined,
  official_book_id: undefined,
  official_book_section_id: undefined,
  author_name: undefined,
  status: undefined
})

const loading = ref<boolean>(true)

const currentPreview = ref<any>()

const previewVisible = ref<boolean>(false)

// 格栅设置
const gutterConfig = {
  gutter: 16,
  xs: 1,
  sm: 2,
  md: 2,
  lg: 2,
  xl: 3,
  xxl: 4
}

const BookTypeMap = {
  OFFICIAL: 1
}

const columns = [
  {
    title: '编号',
    dataIndex: 'id',
    width: 80,
    ellipsis: true
  },
  {
    title: '课件名称',
    dataIndex: 'name',
    width: 150,
    ellipsis: true
  },
  {
    title: '课件类型',
    dataIndex: 'type',
    width: 100,
    slots: { customRender: 'type' }
  },
  {
    title: '学校名称',
    dataIndex: 'author_school_name',
    width: 150,
    ellipsis: true
  },
  {
    title: '学科',
    dataIndex: ['subject', 'name'],
    width: 100,
    ellipsis: true
  },
  {
    title: '出版社',
    dataIndex: ['press_version', 'name'],
    width: 120,
    ellipsis: true
  },

  {
    title: '所属教材',
    dataIndex: ['book', 'name'],
    width: 180,
    ellipsis: true
  },
  {
    title: '所属章节',
    dataIndex: 'section_breadcrumb',
    width: 180,
    ellipsis: true
  },
  {
    title: '作者',
    dataIndex: 'author_name',
    width: 100,
    ellipsis: true
  },
  {
    title: '状态',
    dataIndex: 'status',
    width: 100,
    slots: { customRender: 'status' }
  },
  {
    title: '创建时间',
    dataIndex: 'created_at',
    width: 180
  },
  {
    title: '更新时间',
    dataIndex: 'updated_at',
    width: 180
  },
  {
    title: '操作',
    key: 'action',
    fixed: 'right',
    width: 150,
    slots: { customRender: 'action' }
  }
]

const ListTypeMap = {
  CARD: 'card',
  LIST: 'list'
}

const subjectOpts = ref<any[]>([])
const pressVersionOpts = ref<any[]>([])

const listType = ref<string>(ListTypeMap.CARD)

const showBookName = ref<string>('')

const currentInfo = ref<any>()

const selectBookVisible = ref<boolean>(false)

const { getContextInfo, saveContextInfo, deleteContextInfo } = usePageTableContext()

const handleGetContext = () => {
  const context = getContextInfo(pageTableContextMap.INS_COURSEWARE_DATABASE)
  console.log('get context info ===> ', context)
  const {
    formData: fData,
    currentPage,
    listType: lType,
    showBookName: sbName
  } = context
  // 将值注入到搜索条件中
  if (fData) { formData.value = fData }
  if (lType) { listType.value = lType }
  if (sbName) { showBookName.value = sbName }
  if (currentPage && currentPage > 1) {
    pagination.value.current = currentPage
  }
  deleteContextInfo(pageTableContextMap.INS_COURSEWARE_DATABASE)
}

// 页面进入ppt预览页时，先保存当前的搜索参数到上下文中
const handleSaveContext = () => {
  const pageContext = {
    formData: toRaw(formData.value),
    currentPage: pagination.value.current,
    listType: toRaw(listType.value),
    showBookName: showBookName.value
  }
  saveContextInfo(pageTableContextMap.INS_COURSEWARE_DATABASE, pageContext)
}

// 获取分享到学校内的课件信息
const handleGetTableList = debounce(async (params: any) => {
  const qParams = {
    ...toRaw(formData.value),
    page: pagination.value.current,
    per_page: pagination.value.pageSize,
    ...params
  }
  try {
    loading.value = true
    const { items, meta } = await getInstitutionShareCoursewares(qParams)
    tableData.value = items
    pagination.value = {
      ...toRaw(pagination.value),
      ...meta,
      current: +meta.current_page,
      pageSize: +meta.per_page
    }
    loading.value = false
  } catch (error) {
    console.log(error)
    tableData.value = []
    loading.value = false
  }
})

// 搜索
const handleSearch = (value = {}) => {
  handleGetTableList(value)
}

// table变化
const handleTableChange = (page: any) => {
  console.log(page)
  pagination.value.current = page
  handleGetTableList({})
}

// 分页信息
const pagination = ref({
  current: 1,
  total: 1,
  pageSize: 12,
  showTotal: (total: number) => `共${total}条`,
  onChange: handleTableChange,
  showQuickJumper: true
})
// 上架
const handleShelveStatus = async (id: string) => {
  try {
    loading.value = true
    await enableInstitutionTeacherCourseware(id)
    loading.value = false
    message.success('设置成功')
    handleSearch()
  } catch (error) {
    loading.value = false
    message.error('设置失败，请重试')
  }
}

// 下架
const handleUnshelveStatus = async (id: string) => {
  console.log('handleShelveStatus', id)
  try {
    loading.value = true
    await disableInstitutionTeacherCourseware(id)
    loading.value = false
    message.success('设置成功')
    handleSearch()
  } catch (error) {
    loading.value = false
    message.error('设置失败，请重试')
  }
}

// 更新本地热度数据
const handleUpdateLocalViewNum = (id: string) => {
  tableData.value.forEach(record => {
    if (record.id === id) {
      if (record.popularity && record.popularity.popularity) {
        record.popularity.popularity++
      } else {
        record.popularity.popularity = 1
      }
    }
  })
}

// 预览
const handlePreview = (record: any) => {
  console.log('handlePreview', record)
  currentInfo.value = record
  addInstitutionViewLog(record.id)
  handleUpdateLocalViewNum(record.id)
  if (record.type === CoursewareType.PPT) {
    console.log('PPT preview')
    const id = record.id
    handleSaveContext()
    router.push(`./institution-coursewares/${id}/preview`)
  } else if (record.type === CoursewareType.FLASH) {
    message.info('SWF课件类型暂不支持在线预览')
  } else {
    currentPreview.value = {
      type: record.type,
      url: record.url,
      name: record.name
    }
    previewVisible.value = true
  }
}

// 取消预览
const handlePreviewCancel = () => {
  currentPreview.value = undefined
  previewVisible.value = false
}

const handleShowSelectModal = () => {
  selectBookVisible.value = true
}

const handleResetSelectBook = () => {
  selectBookVisible.value = false
  formData.value.official_book_id = undefined
  formData.value.official_book_section_id = undefined
  showBookName.value = ''
}

// 重置表单搜索
const handleResetForm = () => {
  formData.value = {
    name: undefined,
    author_school_name: undefined,
    type: undefined,
    subject_cat_id: undefined,
    press_version_id: undefined,
    official_book_id: undefined,
    official_book_section_id: undefined,
    author_name: undefined,
    status: undefined
  }
  showBookName.value = ''
  handleSearch({ page: 1 })
}

// 选择教材结束
const handleSelectBookOk = (info: any) => {
  selectBookVisible.value = false
  const { values, labels } = info
  if (values && values.length > 0) {
    if (values[0]) {
      formData.value.official_book_id = values[0]
    }
    if (values[1]) {
      formData.value.official_book_section_id = values[1]
    }
  } else {
    formData.value.official_book_id = undefined
    formData.value.official_book_section_id = undefined
  }
  if (labels && labels.length > 0) {
    showBookName.value = labels.join('/')
  } else {
    showBookName.value = ''
  }
}

const handleGetInsitutionSubjectOpts = async () => {
  try {
    const { subject_cat_data: data } = await getInsSubjectEnum()
    subjectOpts.value = data.map((item: { name: any; id: any }) => ({
      label: item.name,
      value: item.id
    }))
  } catch (err) {
    console.log(err)
    subjectOpts.value = []
  }
}

// 获取出版社信息
const handleGetPressVersionOpts = async () => {
  try {
    const { press_version_cat_data: data } = await getInsPrevissionEnum()
    pressVersionOpts.value = data.map((item: { name: any; id: any }) => ({
      label: item.name,
      value: item.id
    }))
  } catch (err) {
    console.log(err)
    pressVersionOpts.value = []
  }
}

onBeforeMount(() => {
  handleGetContext()
})

onMounted(() => {
  handleGetTableList()
  handleGetInsitutionSubjectOpts()
  handleGetPressVersionOpts()
})

return (_ctx: any,_cache: any) => {
  const _component_a_page_header = _resolveComponent("a-page-header")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_divider = _resolveComponent("a-divider")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _directive_permission_in_slot = _resolveDirective("permission-in-slot")!
  const _directive_permission = _resolveDirective("permission")!

  return _withDirectives((_openBlock(), _createBlock(_component_a_layout, null, {
    default: _withCtx(() => [
      _createVNode(_component_a_page_header, null, {
        title: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_component_a_layout_content, { class: "content_body" }, {
        default: _withCtx(() => [
          _createVNode(_component_a_card, { class: "form_card_body" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form, {
                layout: "inline",
                onKeyup: _cache[8] || (_cache[8] = _withKeys(() => handleSearch({ page: 1 }), ["enter"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_row, {
                    style: {"width":"100%"},
                    gutter: [16, 16]
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "课件名称" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: formData.value.name,
                                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (formData.value.name = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "所属学校" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: formData.value.author_school_name,
                                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (formData.value.author_school_name = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "课件类型" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: _unref(CoursewareTypeOpts),
                                value: formData.value.type,
                                "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (formData.value.type = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "学科" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: subjectOpts.value,
                                value: formData.value.subject_cat_id,
                                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (formData.value.subject_cat_id = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "出版社" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: pressVersionOpts.value,
                                value: formData.value.press_version_cat_id,
                                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (formData.value.press_version_cat_id = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "作者" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input, {
                                value: formData.value.author_name,
                                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (formData.value.author_name = $event))
                              }, null, 8, ["value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "状态" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_select, {
                                options: _unref(CoursewareStatusOpts),
                                value: formData.value.status,
                                "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (formData.value.status = $event)),
                                allowClear: ""
                              }, null, 8, ["options", "value"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, { label: "所属教材章节" }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", {
                                href: "#",
                                onClick: handleShowSelectModal
                              }, [
                                (showBookName.value.length > 15)
                                  ? (_openBlock(), _createBlock(_component_a_tooltip, {
                                      key: 0,
                                      title: showBookName.value
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(showBookName.value.slice(0, 15)) + "... ", 1)
                                      ]),
                                      _: 1
                                    }, 8, ["title"]))
                                  : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(showBookName.value || "请选择教材章节"), 1))
                              ]),
                              _withDirectives(_createVNode(_component_a_button, {
                                style: {"margin-left":"10px"},
                                size: "small",
                                onClick: handleResetSelectBook
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_3
                                ]),
                                _: 1
                              }, 512), [
                                [_vShow, showBookName.value.length > 0]
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_row, {
                    style: {"width":"100%","margin-top":"10px"},
                    gutter: [24, 24],
                    type: "flex",
                    justify: "end"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        md: 8,
                        sm: 24
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createVNode(_component_a_button, {
                              style: {"margin-right":"15px"},
                              onClick: handleResetForm
                            }, {
                              default: _withCtx(() => [
                                _hoisted_5
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _cache[7] || (_cache[7] = () => handleSearch({ page: 1 }))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_a_card, null, {
            extra: _withCtx(() => [
              _createElementVNode("div", {
                style: _normalizeStyle({ color: _unref(store).state.themeColor })
              }, [
                (listType.value === ListTypeMap.CARD)
                  ? (_openBlock(), _createBlock(_unref(UnorderedListOutlined), {
                      key: 0,
                      style: {"font-size":"24px","margin":"4px 8px 0 0"},
                      onClick: _cache[9] || (_cache[9] = () => (listType.value = ListTypeMap.LIST))
                    }))
                  : _createCommentVNode("", true),
                (listType.value === ListTypeMap.LIST)
                  ? (_openBlock(), _createBlock(_unref(AppstoreFilled), {
                      key: 1,
                      style: {"font-size":"24px","margin":"4px 8px 0 0"},
                      onClick: _cache[10] || (_cache[10] = () => (listType.value = ListTypeMap.CARD))
                    }))
                  : _createCommentVNode("", true)
              ], 4)
            ]),
            default: _withCtx(() => [
              _withDirectives(_createElementVNode("div", null, [
                _withDirectives(_createVNode(_component_a_list, {
                  dataSource: tableData.value,
                  pagination: { ...pagination.value, change: handleTableChange },
                  grid: gutterConfig,
                  loading: loading.value
                }, {
                  renderItem: _withCtx(({ item }) => [
                    _createVNode(_component_a_list_item, {
                      key: item.author_courseware_id
                    }, {
                      default: _withCtx(() => [
                        (item.type === _unref(CoursewareType).PPT)
                          ? (_openBlock(), _createBlock(PptCoursewareCard, {
                              key: 0,
                              onOnChangeShelve: handleShelveStatus,
                              onOnChangeUnshelve: handleUnshelveStatus,
                              courseware: item,
                              onOnPreview: handlePreview
                            }, null, 8, ["courseware"]))
                          : _createCommentVNode("", true),
                        (item.type === _unref(CoursewareType).AUDIO)
                          ? (_openBlock(), _createBlock(AudioCoursewareCard, {
                              key: 1,
                              onOnChangeShelve: handleShelveStatus,
                              onOnChangeUnshelve: handleUnshelveStatus,
                              courseware: item,
                              onOnPreview: handlePreview
                            }, null, 8, ["courseware"]))
                          : _createCommentVNode("", true),
                        (item.type === _unref(CoursewareType).VIDEO)
                          ? (_openBlock(), _createBlock(VideoCoursewareCard, {
                              key: 2,
                              onOnChangeShelve: handleShelveStatus,
                              onOnChangeUnshelve: handleUnshelveStatus,
                              courseware: item,
                              onOnPreview: handlePreview
                            }, null, 8, ["courseware"]))
                          : _createCommentVNode("", true),
                        (item.type === _unref(CoursewareType).IMAGE)
                          ? (_openBlock(), _createBlock(ImageCoursewareCard, {
                              key: 3,
                              onOnChangeShelve: handleShelveStatus,
                              onOnChangeUnshelve: handleUnshelveStatus,
                              courseware: item,
                              onOnPreview: handlePreview
                            }, null, 8, ["courseware"]))
                          : _createCommentVNode("", true),
                        (item.type === _unref(CoursewareType).FLASH)
                          ? (_openBlock(), _createBlock(FlashCoursewareCard, {
                              key: 4,
                              onOnChangeShelve: handleShelveStatus,
                              onOnChangeUnshelve: handleUnshelveStatus,
                              courseware: item,
                              onOnPreview: handlePreview
                            }, null, 8, ["courseware"]))
                          : _createCommentVNode("", true),
                        (item.type === _unref(CoursewareType).SPEAK)
                          ? (_openBlock(), _createBlock(SpeakCoursewareCard, {
                              key: 5,
                              onOnChangeShelve: handleShelveStatus,
                              onOnChangeUnshelve: handleUnshelveStatus,
                              courseware: item,
                              onOnPreview: handlePreview
                            }, null, 8, ["courseware"]))
                          : _createCommentVNode("", true),
                        (item.type === _unref(CoursewareType).PLAN)
                          ? (_openBlock(), _createBlock(PlanCoursewareCard, {
                              key: 6,
                              onOnChangeShelve: handleShelveStatus,
                              onOnChangeUnshelve: handleUnshelveStatus,
                              courseware: item,
                              onOnPreview: handlePreview
                            }, null, 8, ["courseware"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                }, 8, ["dataSource", "pagination", "loading"]), [
                  [_vShow, listType.value === ListTypeMap.CARD]
                ])
              ], 512), [
                [_vShow, listType.value === ListTypeMap.CARD]
              ]),
              _withDirectives(_createElementVNode("div", null, [
                _createVNode(_component_a_table, {
                  dataSource: tableData.value,
                  columns: columns,
                  rowKey: "id",
                  pagination: pagination.value,
                  loading: loading.value,
                  scroll: { x: 1300 }
                }, {
                  type: _withCtx(({ text }) => [
                    _createElementVNode("span", null, _toDisplayString(_unref(CoursewareTypeMap)[text] || text), 1)
                  ]),
                  status: _withCtx(({ text }) => [
                    _createVNode(_component_a_tag, {
                      color: _unref(CoursewareStatusMap)[text]?.color
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(CoursewareStatusMap)[text]?.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["color"])
                  ]),
                  action: _withCtx(({ record }) => [
                    _createElementVNode("span", null, [
                      (+record.status === _unref(CoursewareStatus).UNSHELVE)
                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                            key: 0,
                            placement: "left",
                            onConfirm: () => handleShelveStatus(record.id),
                            title: "请确认是否将该课件上架?"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("a", null, _hoisted_8, 512), [
                                [_directive_permission_in_slot, 
                    _unref(PermissionMap).COURSEWARE_DATABASE_INSTITUTION_ENABLE
                  ]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"]))
                        : _createCommentVNode("", true),
                      (+record.status === _unref(CoursewareStatus).SHELVE)
                        ? (_openBlock(), _createBlock(_component_a_popconfirm, {
                            key: 1,
                            placement: "left",
                            onConfirm: () => handleUnshelveStatus(record.id),
                            title: "请确认是否将该课件下架?"
                          }, {
                            default: _withCtx(() => [
                              _withDirectives(_createElementVNode("a", null, _hoisted_10, 512), [
                                [_directive_permission_in_slot, 
                    _unref(PermissionMap).COURSEWARE_DATABASE_INSTITUTION_ENABLE
                  ]
                              ])
                            ]),
                            _: 2
                          }, 1032, ["onConfirm"]))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_divider, { type: "vertical" }),
                      _withDirectives(_createElementVNode("a", {
                        onClick: () => handlePreview(record)
                      }, _hoisted_13, 8, _hoisted_11), [
                        [_directive_permission_in_slot, 
                  _unref(PermissionMap).COURSEWARE_DATABASE_INSTITUTION_PREVIEW
                ]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["dataSource", "pagination", "loading"])
              ], 512), [
                [_vShow, listType.value === ListTypeMap.LIST]
              ])
            ]),
            _: 1
          }),
          (previewVisible.value)
            ? (_openBlock(), _createBlock(PreviewModal, {
                key: 0,
                visible: previewVisible.value,
                currentPreview: currentPreview.value,
                onOnCancel: handlePreviewCancel,
                data: currentInfo.value
              }, null, 8, ["visible", "currentPreview", "data"]))
            : _createCommentVNode("", true),
          (selectBookVisible.value)
            ? (_openBlock(), _createBlock(SelectBookModal, {
                key: 1,
                visible: selectBookVisible.value,
                "onUpdate:visible": _cache[11] || (_cache[11] = ($event: any) => (selectBookVisible.value = $event)),
                onOk: handleSelectBookOk,
                type: BookTypeMap.OFFICIAL
              }, null, 8, ["visible", "type"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512)), [
    [_directive_permission, _unref(PermissionMap).COURSEWARE_DATABASE_INSTITUTION_LIST]
  ])
}
}

})